import React from 'react';
import styles from './Logo.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import logoSrc from '../../assets/logo.png';
import { Link } from 'react-router-dom';

const Logo = ({ className }) => {
  return (
    <Link to={'/'}>
      <img
        className={classNames(styles.logo, className)}
        alt={`Emojimon`}
        src={logoSrc}
      />
    </Link>
  );
};

Logo.propTypes = {
  className: PropTypes.string,
};

Logo.defaultProps = {
  className: null,
};

export default Logo;
